module.exports = __webpack_public_path__ + "img/download.1ac2fe86.svg";